import {
  buildBreadcrumbSchema,
  buildFaqSchema,
  buildHowToSchema,
  buildSoftwareApplicationSchema,
} from '@saas-pages/shared/public/seo'
import { buildCanonical } from '@saas-pages/shared/public/seo'
import branding from '../../branding.config'
import type { Translations } from '@/shared/i18n'

export type QrToolRouteKey =
  | 'qr-generator'
  | 'barcode-generator'
  | 'barcode-scanner'
  | 'qr-scanner'

export function buildQrToolSchemas(
  canonical: string,
  t: Translations,
  routeKey: QrToolRouteKey,
): object[] {
  const schema = routeKey === 'barcode-scanner'
    ? t.barcodeScannerSchema
    : routeKey === 'qr-scanner'
      ? t.scannerSchema
      : routeKey === 'barcode-generator'
        ? t.barcodeSchema
        : t.schema
  const faq = schema.faq

  return [
    buildBreadcrumbSchema([
      { name: branding.domain, url: buildCanonical(branding.domain, '/') },
      { name: schema.name, url: canonical },
    ]),
    buildSoftwareApplicationSchema({
      name: schema.name,
      description: schema.description,
      category: 'UtilitiesApplication',
      url: canonical,
    }),
    buildHowToSchema(schema.name, schema.howTo),
    buildFaqSchema(faq),
  ]
}

export function buildQrToolRouteSchemas(
  path: string,
  t: Translations,
  routeKey: QrToolRouteKey,
): object[] {
  return buildQrToolSchemas(buildCanonical(branding.domain, path), t, routeKey)
}
